"use client";

import { forwardRef } from "react";
import posthog from "posthog-js";

type PostHogProperties = Record<
  string,
  boolean | null | number | string | undefined
>;

interface PostHogCaptureLinkProps
  extends React.ComponentPropsWithoutRef<"a"> {
  eventName?: string;
  eventProperties?: PostHogProperties;
}

export const PostHogCaptureLink = forwardRef<
  HTMLAnchorElement,
  PostHogCaptureLinkProps
>(function PostHogCaptureLink(
  { eventName, eventProperties, onClick, ...props },
  ref
) {
  return (
    <a
      {...props}
      ref={ref}
      onClick={(event) => {
        onClick?.(event);

        if (event.defaultPrevented || !eventName) {
          return;
        }

        posthog.capture(eventName, eventProperties, {
          transport: "sendBeacon",
        });
      }}
    />
  );
});
